import React from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { useMyAccount } from '../context/MyAccountContext';

const ForgotPinForm: React.FC = () => {
  const {
    option,
    formData: formState,
    onInputChange,
    handleForgotPinSubmit,
    handleForgotPinCode,
  } = useMyAccount();
  return (
    option === 'forgotPassword' && (
      <form onSubmit={handleForgotPinSubmit}>
        <Form.Group as={Row} controlId="verificationCode" className="mb-4">
          <Col sm={12} md={7} xl={5}>
            <Form.Label>Verification code</Form.Label>
            <Form.Control
              name="verificationCode"
              type="text"
              onChange={onInputChange}
              maxLength={6}
              value={formState.verificationCode || ''}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} className="mb-4">
          <Col sm={12} md={7} xl={5}>
            <Button
              type="button"
              className="btn btnSecondary btn-long btn-sm float-right"
              onClick={handleForgotPinCode}
            >
              Get code
            </Button>
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="newPin" className="mb-4">
          <Col sm={12} md={7} xl={5}>
            <Form.Label>New PIN</Form.Label>
            <Form.Control
              name="newPin"
              type="password"
              onChange={onInputChange}
              maxLength={4}
              value={formState.newPin}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="confirmPin" className="mb-4">
          <Col sm={12} md={7} xl={5}>
            <Form.Label>Confirm new PIN</Form.Label>
            <Form.Control
              name="confirmPin"
              type="password"
              onChange={onInputChange}
              maxLength={4}
              value={formState.confirmPin}
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="" className="mb-4">
          <Col sm={12} md={7} xl={5}>
            <Button type="submit" className="btn btnPrimary btn-long btn-sm">
              Update PIN
            </Button>
          </Col>
        </Form.Group>
      </form>
    )
  );
};

export default ForgotPinForm;
